// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  globalSettingsUrl: 'https://dev.global.fastcollab.com/',
  BASE_URL:  "https://dev.api.noexpenses.com/gs/",
  DOMAIN_URL: "https://dev.api.noexpenses.com/ne/",
  Environment: "DEV",
  calendarDateFormat: "yyyy-MM-dd",
  apiDateFormat: "dd-MM-yyyy",
  mobileDateFormat: "DD-MM-YYYY",
  mobileCalenderFormat: "YYYY-MM-DD",
  appLogo : 'fc365', //fc365 //expenses
  eva_dashboard_url : 'https://dev.api.eva.travel/tripbox/v1/dashboard/tripbox-stats',
  eva_auth: 'https://dev.api.eva.travel/',
  eva_sso: 'https://dev.sso.eva.travel/eva-sso/sso-login/dev',
  xray_domain: 'https://devdemo.eva.travel/ssoLogin/',
  xray_base: 'https://devdemo.eva.travel',
  EncryptionKey: 'Usdb5aPIHV0TL8Dv',
  Default_SSOLogin: false
};